<template>
  <div class="wrapper">
    <router-link v-if="linkUrl" :to="linkUrl" class="fancy-button pop-onhover bg-gradient" :style="{'font-size':fontSize}"><span :style="spanStyle"><slot></slot></span></router-link>
    <a v-else href="javascript:void(0);" class="fancy-button pop-onhover bg-gradient" :style="{'font-size':fontSize}"><span :style="spanStyle"><slot></slot></span></a>
  </div>
</template>

<script>
  export default {
    name: 'gradient-btn-component',
    props: {
      linkUrl: {type: String},
      width: {type: String, default: '1.4rem'},
      height: {type: String, default: '.38rem'},
      borderRadius: {type: String, default: '.38rem'},
      fontSize: {type: String, default: '.14rem'}
    },
    computed: {
      spanStyle() {
        if (this.width || this.height) {
          return {
            width: this.width,
            height: this.height,
            'line-height': this.height,
            'border-radius': this.borderRadius
          }
        }
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../assets/scss/mixins/gradient";

  .wrapper {
    display: inline-block;
  }
  .bg-gradient span,
  .bg-gradient:before {
    @include gradient-background($deg: 90deg, $bottom-color: #416CF8 0%, $top-color: #EC55FF 100%);
  }
  .bg-gradient .no-bg {
    background: transparent;
  }

  a {
    text-decoration: none;
    &:hover,
    &:focus,
    &:active {
      text-decoration: none;
    }
  }

  .fancy-button {
    text-align: center;
    display: inline-block;
    font-size: .2rem;
    letter-spacing: 0.82px;
    color: #ffffff;
    position: relative;

    &:before {
      content: '';
      display: inline-block;
      height: .3rem;
      position: absolute;
      bottom: -5px;
      left: .1rem;
      right: .1rem;
      z-index: 1;
      border-radius: 30em;
      filter: blur(20px) brightness(0.95);
      transform-style: preserve-3d;
      transition: all 0.3s ease-out;
    }
    span {
      display: inline-block;
      position: relative;
      z-index: 2;
      will-change: transform, filter;
      transform-style: preserve-3d;
      transition: all 0.3s ease-out;
    }
    &:focus,
    &:active {
      color: #ffffff;
    }
    &:hover {
      color: #ffffff;

      span {
        filter: brightness(1.05) contrast(1.05);
        transform: scale(0.95);
      }
      &:before {
        bottom: 0;
        filter: blur(10px) brightness(0.95);
      }
    }
    &.pop-onhover {

      &:before {
        opacity: 0;
        bottom: 10px;
      }
      &:hover {

        &:before {
          bottom: -7px;
          opacity: 1;
          filter: blur(20px);
        }
        span {
          transform: scale(1.04);
        }
        &:active {

          span {
            filter: brightness(1) contrast(1);
            transform: scale(1);
            transition: all 0.15s ease-out;
          }
          &:before {
            bottom: 0;
            filter: blur(10px) brightness(0.95);
            transition: all 0.2s ease-out;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// GradientBtn.vue?5ecd78f4